import Vue from "vue";
import Router from "vue-router";
import Login from "@/views/index/login"; //主页
import store from "@/store";

Vue.use(Router);

const routes = [
  {
    //登录
    path: "/login",
    component: Login
  },
  {
    // 首页
    path: "/index",
    component: () => import("../views/index/index.vue"),
    redirect: to => {
      let userType = localStorage.getItem("userType");
      if (userType == "admin_user") {
        store.dispatch("chooseSchool", false);
        return "/bigDataCenter";
      } else {
        return "/bigDataCenter";
      }
    },
    children: [
      //区县展示
      {
        path: "/map",
        meta: {
          name: "一级"
        },
        component: () => import("../views/map/map.vue")
      },
      // 大数据中心
      {
        path: "/bigDataCenter",
        meta: {
          name: "一级"
        },
        component: () => import("../views/bigDataCenter/bigDataCenter.vue")
      },

      // 大数据总览
      {
        path: "/home",
        meta: {
          name: "一级"
        },
        component: () => import("../views/home/home.vue")
      },
      // 班级管理
      {
        path: "/class",
        meta: {
          name: "一级"
        },
        component: () => import("../views/class/administration.vue")
      },
      // 年级管理
      {
        path: "/grade",
        meta: {
          name: "一级"
        },
        component: () => import("../views/grade/index.vue")
      },
      {
        path: "/standards",
        meta: {
          name: "一级"
        },
        component: () => import("../views/standards/index.vue")
      },
      // 设备管理
      {
        path: "/equipment",
        meta: {
          name: "一级"
        },
        component: () => import("../views/equipment/equipment_sb.vue")
      },
      // 老师管理
      {
        path: "/teacher",
        meta: {
          name: "一级"
        },
        component: () => import("../views/teacher/teacher.vue")
      },
      // 比赛统计
      {
        path: "/statistics",
        meta: {
          name: "一级"
        },
        component: () => import("../views/statistics/statistics.vue")
      },
      // 学校管理
      {
        path: "/customer",
        meta: {
          name: "一级"
        },
        component: () => import("../views/archives/customer.vue")
      },
      //查看班级详情
      {
        path: "/seeClass",
        component: () => import("../views/class/seeClass.vue")
      },
      //1分钟跳绳成绩排行榜
      {
        path: "/scoresRanking",
        // meta: { name: "一级" },
        component: () => import("../views/statistics/scoresRanking.vue")
      },
      //各班级心率异常统计
      {
        path: "/abnormal",
        component: () => import("../views/statistics/abnormal.vue")
      },
      //学术成果列表
      {
        path: "/viewList",
        component: () => import("../views/viewList/viewList.vue")
      },
      //校园比赛列表
      {
        path: "/CampusCompetition",
        component: () =>
          import("../views/campus_competition/CampusCompetition.vue")
      },
      //admin设备管理
      {
        path: "/equipmentAdm",
        meta: {
          name: "一级"
        },
        component: () => import("../views/admin_adm/equipment_adm.vue")
      },
      //admin设备管理查看
      {
        path: "/lookDeivce",
        // meta: { name: "一级" },
        component: () => import("../views/admin_adm/lookDeivce.vue")
      },
      //admin学校管理
      {
        path: "/schoolAdm",
        meta: {
          name: "一级"
        },
        component: () => import("../views/admin_adm/school_adm.vue")
      },
      //比赛用户管理
      {
        path: "/gameUser",
        meta: {
          name: "一级"
        },
        component: () => import("../views/gameUser/gameUser.vue")
      },
      //线上比赛用户管理
      {
        path: "/gameUserOnline",
        meta: {
          name: "一级"
        },
        component: () => import("../views/gameUserOnline/gameUserOnline.vue")
      },
      //比赛设备管理
      {
        path: "/gameEquipment",
        meta: {
          name: "一级"
        },
        component: () => import("../views/gameEquipment/gameEquipment.vue")
      }
    ]
  },
  {
    //默认首页
    path: "",
    redirect: "/index"
  }
];

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});
// 路由变换前
router.beforeEach(function(to, from, next) {
  console.log("路由变化前------", to.path);
  // 判断是否存在token
  if (!localStorage.getItem("token")) {
    // 判断去往的页面是不是登录页
    if (to.path !== "/login") {
      next("/login");
    }
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js